// extracted by mini-css-extract-plugin
export var orderSummary = "_rx-0";
export var showMoreLessButton = "_rx-1";